import { render, staticRenderFns } from "./TermsFreeAnsuranceToJoinKT.vue?vue&type=template&id=5e6c8c18&scoped=true&"
import script from "./TermsFreeAnsuranceToJoinKT.vue?vue&type=script&lang=js&"
export * from "./TermsFreeAnsuranceToJoinKT.vue?vue&type=script&lang=js&"
import style0 from "./TermsFreeAnsuranceToJoinKT.vue?vue&type=style&index=0&id=5e6c8c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c8c18",
  null
  
)

export default component.exports